import { MediaRecorderConfig } from "../../libs/constants/recorder-config";
import CryptoJS from "crypto-js";

export const uploadBlob = async (blob, meetingId, chunkIndex, storageClient) => {
  // Generate a unique block ID using base64 encoding of chunk index
  // Block IDs must be the same length and base64 encoded
  const blockId = btoa(String(chunkIndex).padStart(10, '0'));
  
  const fileName = `raw/meeting_${CryptoJS.MD5(meetingId)}.${MediaRecorderConfig.extension}`;
  console.log("[azure-functions] Starting blob upload:", {
    meetingId,
    fileName,
    blobSize: blob?.size || 0,
    hasStorageClient: !!storageClient
  });
  
  try {
    const result = await storageClient.upload(
      blob,
      fileName,
      blockId,
    );
    console.log("[azure-functions] Blob upload completed successfully:", {
      meetingId,
      fileName,
      blobSize: blob?.size || 0
    });
    return result;
  } catch (error) {
    console.error("[azure-functions] Blob upload failed:", {
      meetingId,
      fileName,
      error: error.message,
      blobSize: blob?.size || 0
    });
    throw error;
  }
};